import { BillingCycleType } from './types';

export const planPrice = (price: number, cycle: BillingCycleType) =>
  `$${price} / ${cycle === 'monthly' ? 'month' : 'year'}`;
